import React, { useEffect, useState } from 'react';
import { Table, Button, message, InputNumber, Popover, Row, Select, Form, Col, Input, Empty, Card, Checkbox, Descriptions, Flex, Tag, Divider } from 'antd';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';
import moment from 'moment';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import SpinLoading from './SpinLoading';
import { useMediaQuery } from 'react-responsive';
import usePermissions from '../../hooks/usePermissions';

const MobileTableRemoveFl = ({
    freelancers,
    handleEditSave,
    editingRow,
    setEditingRow,
    editingBudget,
    setEditingBudget,
    actionsLoading,
    deletingRow,
    setDeletingRow,
    handleDeleteSelected
}) => {

    const { hasPermission } = usePermissions();

    return (
        <div style={{ backgroundColor: "#f2f6f9", padding: '10px', marginTop: "20px" }}>
            {freelancers && freelancers.length > 0 ? (
                freelancers.map((items, index) => (
                    <Card style={{ marginBottom: "10px" }}>
                        <Descriptions bordered size="small">
                            <Descriptions.Item label="INR Budget">
                                {items.inr_budget || "N/A"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Converted">
                                <Tag color="purple">{items.converted ? "Yes" : "No"}</Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="Created">
                                {items.created
                                    ? moment(items.created)
                                        .local()
                                        .format("DD-MM-YYYY hh:mm A")
                                    : "N/A"}
                            </Descriptions.Item>
                            {hasPermission("can_edit_freelancer_budget") && (
                                <Descriptions.Item label="Edit Budget">
                                    <Popover
                                        content={
                                            <div style={{ width: 200 }}>
                                                <InputNumber
                                                    defaultValue={parseFloat(items.inr_budget)}
                                                    min={0}
                                                    style={{ width: '100%', marginBottom: 10 }}
                                                    formatter={value => `₹ ${value}`}
                                                    parser={value => value.replace(/₹\s?|(,*)/g, '')}
                                                    onChange={setEditingBudget}
                                                />
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    onClick={() => handleEditSave(items.uid, editingBudget)}
                                                    loading={actionsLoading?.editLoading && editingRow === items.uid}
                                                    block
                                                >
                                                    {actionsLoading?.editLoading && editingRow === items.uid ? 'Saving...' : 'Save'}
                                                </Button>
                                            </div>
                                        }
                                        title="Edit Budget"
                                        trigger="click"
                                        open={editingRow === items.uid}
                                        onOpenChange={(visible) => {
                                            if (visible) {
                                                setEditingRow(items.uid);
                                                setEditingBudget(parseFloat(items.inr_budget));
                                            } else {
                                                setEditingRow(null);
                                            }
                                        }}
                                        placement='center'
                                    >
                                        <Button type="link" icon={<EditOutlined />} />
                                    </Popover>
                                </Descriptions.Item>
                            )}
                            {hasPermission("can_delete_freelancer_budget") && (
                                <Descriptions.Item label="Delete Budget">
                                    <Popover
                                        title="Confirm Delete FL Budget"
                                        trigger="click"
                                        open={deletingRow === items.uid}
                                        onOpenChange={(visible) => {
                                            if (visible) {
                                                setDeletingRow(items.uid);
                                            } else {
                                                setDeletingRow(null);
                                            }
                                        }}
                                        content={
                                            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    loading={actionsLoading.deleteLoading}
                                                    onClick={() => handleDeleteSelected(items.uid)}
                                                >
                                                    Yes
                                                </Button>
                                                <Button
                                                    size="small"
                                                    onClick={() => setDeletingRow(null)}
                                                >
                                                    No
                                                </Button>
                                            </div>
                                        }
                                        placement='left'
                                    >
                                        <Button type="link" icon={<DeleteOutlined style={{ color: "red", fontSize: "18px" }} />} />
                                    </Popover>
                                </Descriptions.Item>
                            )}
                        </Descriptions>

                    </Card>
                ))
            ) : (
                <Empty description="No data available" />
            )}
        </div>
    )
}

const RemoveFlBudget = ({ setRenderStatic }) => {

    // add freelancers budget

    const { orderKey } = useParams();
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [currencyData, setCurrencyData] = useState([]);
    const [form] = Form.useForm();
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { hasPermission } = usePermissions();


    const fetchCurrencies = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get('api/v2/currency/all/');
            // console.log("RESSS", res)
            if (res?.data?.status === "success") {
                setCurrencyData(res?.data?.data?.currency);
            }
        } catch (err) {
            console.error("Error fetching currencies:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCurrencies();
    }, []);

    const handleSubmit = async (values) => {
        setSubmitLoading(true);
        const payload = {
            budget: values.budget,
            currency: values.currency,
        };

        try {
            const response = await axiosInstance.post(`/task/v2/add-fl-budget/${orderKey}/`, payload);
            if (response.status === 200 && response.data.status === 'success') {
                message.success(response.data.data);
                form.resetFields();
                fetchFreelancerBudgets()
                setRenderStatic(true)
            }
        } catch (error) {
            await catchError(error)
        } finally {
            setSubmitLoading(false);
        }
    };


    // remove and edit freelancers budget
    const [freelancers, setFreelancers] = useState([]);
    const [editingRow, setEditingRow] = useState(null);
    const [editingBudget, setEditingBudget] = useState(null);
    const [deletingRow, setDeletingRow] = useState(null);

    const [actionsLoading, setActionsLoading] = useState({
        deleteLoading: false,
        editLoading: false
    });

    const fetchFreelancerBudgets = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/task/v2/delete-freelancer-budget/${orderKey}/`);
            if (response?.status === 200 && response.data?.status === "success") {
                setFreelancers(response.data.data);
            }
        } catch (error) {
            console.log("Error fetching freelancer budgets:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFreelancerBudgets();
    }, [orderKey]);

    const handleEditSave = async (uid) => {



        setActionsLoading({
            deleteLoading: false,
            editLoading: true
        });
        try {
            setLoading(true);
            const response = await axiosInstance.post(`/task/v2/edit-freelancer-budget/${uid}/`, {
                inr_budget: editingBudget,
            });

            if (response.status === 200 && response.data?.status === "success") {
                message.success(response.data.data);
                fetchFreelancerBudgets();
                setEditingRow(null);
                setRenderStatic(true)
            } else {
                message.error("Failed to update budget.");
            }
        } catch (error) {
            await catchError(error);
        } finally {
            setLoading(false);
            setActionsLoading({
                deleteLoading: false,
                editLoading: false
            });
        }
    };

    const handleDeleteSelected = async (uid) => {
        setActionsLoading({
            deleteLoading: true,
            editLoading: false
        });
        try {
            setLoading(true);

            const response = await axiosInstance.post(`/task/v2/delete-freelancer-budget/${orderKey}/`, {
                uids: uid
            });

            if (response.status === 200 && response.data?.status === "success") {
                message.success(response.data.data, 5);
                fetchFreelancerBudgets();
                setRenderStatic(true)
            }
        } catch (error) {
            await catchError(error);
            setActionsLoading({
                deleteLoading: false,
                editLoading: false
            });
        } finally {
            setLoading(false);
            setActionsLoading({
                deleteLoading: false,
                editLoading: false
            });
        }
    };

    const columns = [
        {
            title: 'INR Budget',
            dataIndex: 'inr_budget',
            key: 'inr_budget',
            render: (text) => `₹${parseFloat(text).toFixed(2)}`
        },
        {
            title: 'Converted',
            dataIndex: 'converted',
            key: 'converted',
            render: (value) => value ? 'Yes' : 'No'
        },
        {
            title: 'Created at',
            dataIndex: 'created',
            key: 'created',
            render: (value) => moment(value).format('DD-MM-YYYY hh:mm A')
        },
        ...hasPermission("can_edit_freelancer_budget") ? [{
            title: 'Edit',
            key: 'edit',
            render: (_, record) => (
                <Popover
                    content={
                        <div style={{ width: 200 }}>
                            <InputNumber
                                defaultValue={parseFloat(record.inr_budget)}
                                min={0}
                                style={{ width: '100%', marginBottom: 10 }}
                                formatter={value => `₹ ${value}`}
                                parser={value => value.replace(/₹\s?|(,*)/g, '')}
                                onChange={setEditingBudget}
                            />
                            <Button
                                type="primary"
                                size="small"
                                onClick={() => handleEditSave(record.uid)}
                                loading={actionsLoading.editLoading}
                                block
                            >
                                {actionsLoading.editLoading ? 'Saving...' : 'Save'}
                            </Button>
                        </div>
                    }
                    title="Edit Budget"
                    trigger="click"
                    open={editingRow === record.uid}
                    onOpenChange={(visible) => {
                        if (visible) {
                            setEditingRow(record.uid);
                            setEditingBudget(parseFloat(record.inr_budget));
                        } else {
                            setEditingRow(null);
                        }
                    }}
                    placement='left'
                >
                    <Button type="link" icon={<EditOutlined />} />
                </Popover>
            )
        }] : [],
        ...hasPermission("can_delete_freelancer_budget") ? [{
            title: "Delete",
            dataIndex: "Delete",
            key: "Delete",
            render: (_, record) => (
                <Popover
                    title="Confirm Delete FL Budget"
                    trigger="click"
                    open={deletingRow === record.uid}
                    onOpenChange={(visible) => {
                        if (visible) {
                            setDeletingRow(record.uid);
                        } else {
                            setDeletingRow(null);
                        }
                    }}
                    content={
                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                            <Button
                                type="primary"
                                size="small"
                                loading={actionsLoading.deleteLoading}
                                onClick={() => handleDeleteSelected(record.uid)}
                            >
                                Yes
                            </Button>
                            <Button
                                size="small"
                                onClick={() => setDeletingRow(null)}
                            >
                                No
                            </Button>
                        </div>
                    }
                    placement='left'
                >
                    <Button type="link" icon={<DeleteOutlined style={{ color: "red", fontSize: "18px" }} />} />
                </Popover>
            ),
        }] : [],

    ];

    return (
        <div>
            {loading && !freelancers.length ? (
                <SpinLoading />
            ) : (
                <div>

                    <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "16px" }}>Add FL Budget</div>
                    <Form form={form} layout='vertical' onFinish={handleSubmit}>
                        <Row
                            style={{
                                flexDirection: isMobile ? "column" : "row",
                                width: "100%",
                            }}
                            gutter={12}
                        >
                            <Col order={1} lg={10}>
                                <Form.Item
                                    style={{ width: "100%" }}
                                    name="budget"
                                    // label="Budget"
                                    rules={[{ required: true, message: 'Please enter your budget!' }]}
                                >
                                    <Input placeholder="Enter budget amount" type="number" />
                                </Form.Item>
                            </Col>

                            <Col order={2} lg={10}>
                                <Form.Item
                                    style={{ width: "100%" }}
                                    name="currency"
                                    rules={[{ required: true, message: 'Please select a currency!' }]}
                                >
                                    <Select placeholder="Select a currency" style={{ width: '100%' }}>
                                        {currencyData.length > 0 ? (
                                            currencyData.map((currency) => (
                                                <Select.Option key={currency} value={currency}>
                                                    {currency}
                                                </Select.Option>
                                            ))
                                        ) : (
                                            <Select.Option value="" disabled>
                                                No currencies available
                                            </Select.Option>
                                        )}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col style={{ textAlign: isMobile && "right", }} order={3} lg={4}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={submitLoading}
                                    style={{ width: isMobile ? "auto" : "100%", }}
                                >
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <div style={{ paddingRight: "10px" }}>

                        <Divider orientation='center'>Budget Overview</Divider>

                        {isMobile ? (
                            <MobileTableRemoveFl
                                freelancers={freelancers}
                                handleEditSave={handleEditSave}
                                editingRow={editingRow}
                                setEditingRow={setEditingRow}
                                editingBudget={editingBudget}
                                setEditingBudget={setEditingBudget}
                                actionsLoading={actionsLoading}
                                deletingRow={deletingRow}
                                setDeletingRow={setDeletingRow}
                                handleDeleteSelected={handleDeleteSelected}
                            />
                        ) : (
                            <Table
                                rowKey="uid"
                                dataSource={freelancers}
                                columns={columns}
                                pagination={false}
                            />
                        )}
                    </div>

                </div>
            )}
        </div>
    );
};

export default RemoveFlBudget;
